import logoImg from "@/assets/logo-euronova.png";

const EuronovaLogo = ({ className = "" }: { className?: string }) => {
  return (
    <div className={`inline-flex items-center ${className}`}>
      <img src={logoImg} alt="Euro Nova" className="h-full w-auto" width={1890} height={737} />
    </div>
  );
};

export default EuronovaLogo;
